export const registrationClientContext = {
  firstStage: '/user-service/api/external/companies/registration/firstStage',
  secondStageSeller: '/user-service/api/external/companies/registration/secondStage/legalSeller',
  secondStageBuyer: '/user-service/api/external/companies/registration/secondStage/legalBuyer',

  thirdStage: '/user-service/api/external/companies/registration/thirdStage',
  reset: '/user-service/api/external/companies/registration/reset',

  organizationTypes: '/user-service/api/external/organizationTypes',
  companyRegions: '/user-service/api/external/companyRegions',
};
